import { HostListener, Renderer2 } from '@angular/core';
// import { InlineEditorComponent } from "@qontu/ngx-inline-editor";

export class InlineEditorExtension {

  // public editModeEnabled: boolean = false;
  //
  // constructor(public renderer: Renderer2) {}
  //
  // getElement(editor){
  //   return editor.toArray();
  // }
  //
  // @HostListener('keyup',['$event.target']) keyup(target) {
  //   if(target.classList.contains('error')){
  //     this.renderer.removeClass(target,'error');
  //   }
  // }
  //
  // disableEditMode(elements,actionsComp){
  //   elements.forEach((editor:InlineEditorComponent) => {
  //     editor.cancel({
  //       state: editor.state.getState()
  //     });
  //   });
  //
  //   actionsComp.editBasicDetailsModeEnabled = false;
  //   this.editModeEnabled = false;
  // }

}
